





















































































































































import { Component, Vue, Prop, Watch, Mixins } from 'vue-property-decorator';
import VehicleService from '@/services/vehicle.service';
import LoginService from '@/services/login.service';
import VehicleDetail from '@/models/VehicleDetail';
import eventBus from '@/common/bus';
import Shared from '@/common/shared';
import BaseServiceMixin from '@/mixins/base.service.mixin';
import StoreVuexModule, { UserModel } from '@/stores/StoreVuexModule';
import { getModule } from 'vuex-module-decorators';

@Component({
  name: 'RegNumberSearch',
})
export default class RegNumberSearch extends Mixins(BaseServiceMixin) {
  @Prop({
    default: () => new VehicleDetail(),
  })
  public value!: VehicleDetail;

  private localDetail: VehicleDetail = new VehicleDetail();
  private isDisabled: boolean = false;

  private registrationNumber: string = '';
  private RegistrationRules = [
    // (v: string) => /^[A-Za-z0-9]*$/.test(v) || Shared.messages.INVALID_REGISTRATION_NO,
    // (v: string) => !!v || Shared.messages.INVALID_REGISTRATION_NO,
    (v: string) =>
      (!!v && /^([A-Za-z0-9]+( )?[A-Za-z0-9]*)$/.test(v)) ||
      Shared.messages.INVALID_REGISTRATION_NO,
  ];
  private vehicleService!: VehicleService;
  private loginService!: LoginService;
  private store!: StoreVuexModule;

  public created() {
    this.vehicleService = new VehicleService(this.axiosInstance);
    this.loginService = new LoginService();
    this.store = getModule(StoreVuexModule, this.$store);
  }

  private mounted() {
    this.updateInternalStore();
  }

  @Watch('value', { deep: true })
  private updateInternalStore() {
    this.localDetail = Object.assign({}, this.value);
    this.isDisabled = false;
  }

  private get form(): any {
    return this.$refs.formRegistration;
  }

  private async onSearch() {
    this.isDisabled = true;
    if (this.form.validate()) {
      try {
        const details:
          | VehicleDetail
          | null
          | string = await this.vehicleService.GetVehicleByRegNo(
          this.registrationNumber,
        );

        eventBus.$emit('track', 'SearchVehicle', {
          type: 'Registration',
          vehicleFound: details !== null && typeof(details) === 'object',
          vehicleDetails: details && typeof(details) === 'object' && {
              makeId: details.makeId,
              make: details.make,
              modelGroupId: details.modelGroupId,
              modelGroup: details.modelGroup,
              modelId: details.modelId,
              model: details.model,
              yearModel: details.yearModel,
              year: details.year,
              seatCount: details.seats,
              transmissionId: details.transmissionId,
              transmission: details.transmission,
              imageURL: details.imageURL,
            },
        });

        if (details && typeof(details) === 'object') {
          this.localDetail = details;
          this.localDetail.regNo = this.registrationNumber;
        } else {
          this.resetLocalDetails();
          eventBus.$emit(
            'errorHandler',
            Shared.messages.INVALID_REGISTRATION_NO,
            true,
          );
        }
      } catch (err) {
        // TODO: handle error
      } finally {
        this.$emit('input', this.localDetail);
      }
    } else {
      this.resetLocalDetails();
    }
    this.isDisabled = false;
  }

  private resetLocalDetails() {
    this.localDetail = new VehicleDetail();
  }

  private resetValidation() {
    this.form.resetValidation();
  }
}
